










































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";

const DEFAULT_DATE = "";
@Component({
  model: {
    prop: "value",
    event: "input",
  },
  watch: {
    value: "setValue",
  },
})
export default class DatePicker extends Vue {
  @Prop({ default: () => true })
  readonly showPI: boolean;

  @Prop()
  readonly value: string;

  @Prop({ default: false })
  readonly outlined: boolean;

  @Prop({ default: null })
  readonly label: string;

  @Prop({ default: "" })
  readonly placeholder: string;

  @Prop({ default: false })
  readonly clearable: boolean;

  @Prop({ default: null })
  readonly min: string;

  @Prop({ default: null })
  readonly max: string;

  @Prop({ default: () => [] })
  readonly rules: any;

  @Prop({ default: true })
  readonly dense: boolean;

  @Prop({ default: true })
  readonly hideDetails: boolean;

  display = false;
  date = "";

  get formattedDate() {
    if (!this.value) return null;
    return moment(this.value, "YYYY-MM-DD").format("DD.MM.YYYY");
  }

  okHandler() {
    this.resetPicker();
    this.$emit("input", this.date);
  }
  resetPicker() {
    this.display = false;
  }
  clearHandler() {
    this.resetPicker();
    this.date = DEFAULT_DATE;
    this.$emit("input", undefined);
  }
  setValue(date: string) {
    this.date = date;
  }
}
